import React from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../ui/PageShell';
import { PageHeader } from '../ui/PageHeader';
import { NotificationPreferences } from './NotificationCenter';
import PageBackLink from '../ui/PageBackLink';

/**
 * Full-page preference center for notifications and email categories.
 * Mounted at NOTIFICATION_PREFERENCES_PATH (/settings/notifications).
 */
const NotificationPreferencesPage: React.FC = () => (
  <PageShell>
    <PageBackLink label="Back to Garage" to="/garage" className="mb-4" />
    <PageHeader
      eyebrow="Settings"
      title="Notifications and email"
      description="Organize updates by what you care about. Account and security messages stay on."
    />
    <p className="text-sm text-zinc-400 mb-6 max-w-2xl">
      For cookie choices, marketing opt-out, export, and deletion, use{' '}
      <Link to="/settings/privacy" className="text-orange-300 hover:text-orange-200 underline-offset-2 hover:underline">
        Privacy and data
      </Link>
      .
    </p>
    <NotificationPreferences />
  </PageShell>
);

export default NotificationPreferencesPage;
